import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const SettingsSwitch = ({toggleData, handleChange}) => {

  const isChecked = toggleData !== undefined ? toggleData : false;

  return (
    <FormControlLabel
      value="end"
      control={<Switch 
                color="success" 
                checked={isChecked}
                onChange={handleChange}/>}
    />
  );
};

export default SettingsSwitch;